import _defineProperty from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectWithoutProperties from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["className", "label", "loading", "optionProps", "value", "defaultValue", "valueChange", "onChange", "error", "errMessage", "showValueTextLength", "disableClearable", "isFilterWithLabelValue", "isFuzzyFilter", "fuzzyFilterFields", "formTitleDirection", "formTitle", "formTitleClassName", "formTitleSlot", "filterOptions"],
    _excluded2 = ["name", "control", "rules", "defaultValue", "valueChange", "containerClassName"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef, useImperativeHandle, useMemo, useState } from 'react';
import { StyleTextField } from '@jove-frontend/mui';
import { Autocomplete, Box, CircularProgress, Typography, createFilterOptions } from '@mui/material';
import clsx from 'clsx';
import { useController } from 'react-hook-form';
import { createFuzzyOptionsFilter } from '../../utils/text';
import { JoveFormErrorInfoView } from '../form/JoveFormErrorInfoView';
import { JoveFormTitleDirectionEnum } from '../types';
import { jsx as _jsx } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var JoveAutocomplete = /*#__PURE__*/forwardRef(function (props, ref) {
  var className = props.className,
      label = props.label,
      loading = props.loading,
      _props$optionProps = props.optionProps,
      optionProps = _props$optionProps === void 0 ? {
    value: 'value',
    label: 'label'
  } : _props$optionProps,
      value = props.value,
      defaultValue = props.defaultValue,
      valueChange = props.valueChange,
      onChange = props.onChange,
      error = props.error,
      errMessage = props.errMessage,
      showValueTextLength = props.showValueTextLength,
      disableClearable = props.disableClearable,
      isFilterWithLabelValue = props.isFilterWithLabelValue,
      isFuzzyFilter = props.isFuzzyFilter,
      fuzzyFilterFields = props.fuzzyFilterFields,
      _props$formTitleDirec = props.formTitleDirection,
      formTitleDirection = _props$formTitleDirec === void 0 ? JoveFormTitleDirectionEnum.top : _props$formTitleDirec,
      formTitle = props.formTitle,
      formTitleClassName = props.formTitleClassName,
      formTitleSlot = props.formTitleSlot,
      filterOptions = props.filterOptions,
      rest = _objectWithoutProperties(props, _excluded);

  var _useState = useState(defaultValue || null),
      inputValue = _useState[0],
      setInputValue = _useState[1]; // token-based fuzzy filter matching the option label field plus any extra fuzzyFilterFields


  var fuzzyFilterFieldsKey = (fuzzyFilterFields !== null && fuzzyFilterFields !== void 0 ? fuzzyFilterFields : []).join(',');
  var fuzzyFilterOptions = useMemo(function () {
    var extraFields = fuzzyFilterFieldsKey ? fuzzyFilterFieldsKey.split(',') : [];
    return createFuzzyOptionsFilter(function (option) {
      return [option === null || option === void 0 ? void 0 : option[optionProps.label]].concat(_toConsumableArray(extraFields.map(function (field) {
        return option === null || option === void 0 ? void 0 : option[field];
      }))).filter(Boolean).join(' ');
    });
  }, [optionProps.label, fuzzyFilterFieldsKey]);
  /**
   * methods
   */

  var selectChangeAction = function selectChangeAction(event, newValue) {
    onChange === null || onChange === void 0 ? void 0 : onChange(event);
    setInputValue(newValue);
    valueChange === null || valueChange === void 0 ? void 0 : valueChange(newValue);
  }; // update current select item


  var updateSelectItem = function updateSelectItem(item) {
    setInputValue(item);
  };

  useImperativeHandle(ref, function () {
    return {
      updateSelectItem: updateSelectItem
    };
  });

  var getFormTitleComponent = function getFormTitleComponent(direction) {
    return formTitleSlot ? formTitleSlot : !!formTitle ? /*#__PURE__*/_jsx(Typography, {
      variant: "subtitle2",
      className: clsx('font-bold', formTitleClassName, direction === JoveFormTitleDirectionEnum.top ? 'mb-1' : ''),
      style: {
        color: props !== null && props !== void 0 && props.disabled ? 'rgba(0, 0, 0, 0.38)' : undefined
      },
      children: formTitle
    }) : null;
  };

  return /*#__PURE__*/_jsxs(Box, {
    className: clsx('flex flex-col', className),
    children: [formTitleDirection === JoveFormTitleDirectionEnum.top && getFormTitleComponent(formTitleDirection), /*#__PURE__*/_jsxs(Box, {
      className: "flex w-full flex-row items-center space-x-2",
      children: [formTitleDirection === JoveFormTitleDirectionEnum.left && getFormTitleComponent(formTitleDirection), /*#__PURE__*/_jsxs(Box, {
        className: "flex w-0 flex-1 flex-col",
        children: [/*#__PURE__*/_jsx(Autocomplete, _objectSpread(_objectSpread({
          ref: ref,
          isOptionEqualToValue: function isOptionEqualToValue(option, value) {
            return (option === null || option === void 0 ? void 0 : option[optionProps === null || optionProps === void 0 ? void 0 : optionProps.value]) === (value === null || value === void 0 ? void 0 : value[optionProps === null || optionProps === void 0 ? void 0 : optionProps.value]);
          },
          getOptionLabel: function getOptionLabel(option) {
            var _String;

            var uniqueValueText = (_String = String(option[optionProps === null || optionProps === void 0 ? void 0 : optionProps.value])) === null || _String === void 0 ? void 0 : _String.slice(0, showValueTextLength);
            return "".concat(option[optionProps.label]).concat(!!showValueTextLength && uniqueValueText ? '  (' + uniqueValueText + ')' : '');
          },
          renderOption: function renderOption(props, option) {
            return /*#__PURE__*/_createElement("li", _objectSpread(_objectSpread({}, props), {}, {
              key: option[optionProps.value] + props.id
            }), option[optionProps.label]);
          }
        }, rest), {}, {
          value: value === undefined ? inputValue : value !== null && value !== void 0 ? value : null,
          loading: loading,
          onChange: selectChangeAction,
          filterOptions: filterOptions ? filterOptions : isFuzzyFilter ? fuzzyFilterOptions : isFilterWithLabelValue ? createFilterOptions({
            matchFrom: 'start',
            stringify: function stringify(option) {
              return option[optionProps.label];
            }
          }) : undefined,
          renderInput: function renderInput(params) {
            return /*#__PURE__*/_jsx(StyleTextField, _objectSpread(_objectSpread({}, params), {}, {
              label: label,
              InputProps: _objectSpread(_objectSpread({}, params.InputProps), {}, {
                endAdornment: /*#__PURE__*/_jsxs(_Fragment, {
                  children: [loading ? /*#__PURE__*/_jsx(CircularProgress, {
                    color: "inherit",
                    size: 20
                  }) : null, params.InputProps.endAdornment]
                })
              })
            }));
          },
          disableClearable: disableClearable
        })), /*#__PURE__*/_jsx(JoveFormErrorInfoView, {
          error: error,
          errMessage: errMessage
        })]
      })]
    })]
  });
});
export var JoveAutocompleteControlled = /*#__PURE__*/forwardRef(function (props, ref) {
  var name = props.name,
      control = props.control,
      rules = props.rules,
      defaultValue = props.defaultValue,
      valueChange = props.valueChange,
      containerClassName = props.containerClassName,
      rest = _objectWithoutProperties(props, _excluded2);

  var _useController = useController({
    name: name,
    control: control,
    rules: rules,
    defaultValue: defaultValue
  }),
      _useController$field = _useController.field,
      value = _useController$field.value,
      onChange = _useController$field.onChange,
      error = _useController.fieldState.error;

  var valueChangeAction = function valueChangeAction(value) {
    onChange === null || onChange === void 0 ? void 0 : onChange(value);
    valueChange === null || valueChange === void 0 ? void 0 : valueChange(value);
  };

  return /*#__PURE__*/_jsx(Box, {
    className: clsx('flex flex-col', containerClassName),
    children: /*#__PURE__*/_jsx(JoveAutocomplete, _objectSpread(_objectSpread({}, rest), {}, {
      ref: ref,
      value: value,
      valueChange: valueChangeAction,
      defaultValue: defaultValue,
      error: !!error,
      errMessage: error === null || error === void 0 ? void 0 : error.message
    }))
  });
});
export default JoveAutocomplete;